"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jwt_decode_1 = __importDefault(require("jwt-decode"));
var query_string_1 = __importDefault(require("query-string"));
var environments_1 = require("./environments");
var startUri = window.location.origin + "/sign-popup-start.html";
var redirectUri = window.location.origin + "/sign-popup-callback.html";
var SignError = /** @class */ (function () {
    function SignError(message) {
        this.message = message;
    }
    return SignError;
}());
exports.SignError = SignError;
// tslint:disable-next-line:max-classes-per-file
var SignManager = /** @class */ (function () {
    function SignManager(signOptions) {
        var _this = this;
        this.signOptions = signOptions;
        this.rejectActiveSignRequest = null;
        this.collect = function (collectId) { return __awaiter(_this, void 0, void 0, function () {
            var collectResp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.gql({
                            query: "mutation CollectSign { signCollect(collectId: \"" + collectId + "\") { signature } }"
                        })];
                    case 1:
                        collectResp = _a.sent();
                        return [2 /*return*/, collectResp.data.signCollect.signature];
                }
            });
        }); };
        this.collectMany = function (collectId) { return __awaiter(_this, void 0, void 0, function () {
            var collectResp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.gql({
                            query: "mutation CollectSignMany { signManyCollect(collectId: \"" + collectId + "\") { signatures } }"
                        })];
                    case 1:
                        collectResp = _a.sent();
                        return [2 /*return*/, collectResp.data.signManyCollect.signatures];
                }
            });
        }); };
    }
    SignManager.prototype.sign = function (text, data, preOpenedPopup) {
        return __awaiter(this, void 0, void 0, function () {
            var popup, signQuery, ex_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.rejectActiveSignRequest !== null) {
                            this.rejectActiveSignRequest();
                        }
                        popup = preOpenedPopup || this.openPopup();
                        this.rejectActiveSignRequest = function () { return popup.close(); };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        signQuery = this.createSignStartQuery(text, data);
                        return [4 /*yield*/, this.signNoErrorHandling(signQuery, this.collect, popup)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        ex_1 = _a.sent();
                        console.log("Sign aborted due to exception: ", ex_1);
                        throw ex_1;
                    case 4:
                        popup.close();
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    SignManager.prototype.signMany = function (text, dataObjects, preOpenedPopup) {
        return __awaiter(this, void 0, void 0, function () {
            var popup, signQuery, ex_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.rejectActiveSignRequest !== null) {
                            this.rejectActiveSignRequest();
                        }
                        popup = preOpenedPopup || this.openPopup();
                        this.rejectActiveSignRequest = function () { return popup.close(); };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        signQuery = this.createSignManyStartQuery(text, dataObjects);
                        return [4 /*yield*/, this.signNoErrorHandling(signQuery, this.collectMany, popup)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        ex_2 = _a.sent();
                        console.log("Sign aborted due to exception: ", ex_2);
                        throw ex_2;
                    case 4:
                        popup.close();
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    SignManager.prototype.signJson = function (text, obj, preOpenedPopup) {
        return __awaiter(this, void 0, void 0, function () {
            var popup, signQuery, ex_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.rejectActiveSignRequest !== null) {
                            this.rejectActiveSignRequest();
                        }
                        popup = preOpenedPopup || this.openPopup();
                        this.rejectActiveSignRequest = function () { return popup.close(); };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        signQuery = this.createSignJsonStartQuery(text, JSON.stringify(obj));
                        return [4 /*yield*/, this.signNoErrorHandling(signQuery, this.collect, popup)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        ex_3 = _a.sent();
                        console.log("Sign aborted due to exception: ", ex_3);
                        throw ex_3;
                    case 4:
                        popup.close();
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    SignManager.prototype.signManyJson = function (text, objs, preOpenedPopup) {
        return __awaiter(this, void 0, void 0, function () {
            var popup, signQuery, ex_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.rejectActiveSignRequest !== null) {
                            this.rejectActiveSignRequest();
                        }
                        popup = preOpenedPopup || this.openPopup();
                        this.rejectActiveSignRequest = function () { return popup.close(); };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        signQuery = this.createSignManyJsonStartQuery(text, objs.map(function (x) { return JSON.stringify(x); }));
                        return [4 /*yield*/, this.signNoErrorHandling(signQuery, this.collectMany, popup)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        ex_4 = _a.sent();
                        console.log("Sign aborted due to exception: ", ex_4);
                        throw ex_4;
                    case 4:
                        popup.close();
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    SignManager.prototype.openPopup = function () {
        var requestedWidth = 500;
        var requestedHeight = 600;
        // https://stackoverflow.com/questions/4068373/center-a-popup-window-on-screen
        var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screen.left;
        var dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screen.top;
        var width = window.innerWidth
            ? window.innerWidth
            : document.documentElement.clientWidth
                ? document.documentElement.clientWidth
                : window.screen.width;
        var height = window.innerHeight
            ? window.innerHeight
            : document.documentElement.clientHeight
                ? document.documentElement.clientHeight
                : window.screen.height;
        var left = width / 2 - requestedWidth / 2 + dualScreenLeft;
        var top = height / 2 - requestedHeight / 2 + dualScreenTop;
        var popupFeatures = "location=no,toolbar=no,width=" + requestedWidth + ",height=" + requestedHeight + ",left=" + left + ",top=" + top;
        var popupTarget = "SigningWindow";
        var signPopup = window.open(startUri, popupTarget, popupFeatures);
        signPopup.focus();
        return signPopup;
    };
    SignManager.prototype.createSignStartQuery = function (text, data) {
        var _this = this;
        return function (userId, clientId) { return __awaiter(_this, void 0, void 0, function () {
            var resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.gql({
                            query: "\n        mutation StartSign($userId: String!, $clientId: String!, $text: String!, $data: String!) { \n          signResponse: signStart(text: $text, data: $data, clientId: $clientId, userId: $userId) { \n            requestId, \n            collectId \n          } \n        }",
                            variables: {
                                text: text,
                                data: data,
                                userId: userId,
                                clientId: clientId
                            }
                        })];
                    case 1:
                        resp = _a.sent();
                        return [2 /*return*/, {
                                requestId: resp.data.signResponse.requestId,
                                collectId: resp.data.signResponse.collectId
                            }];
                }
            });
        }); };
    };
    SignManager.prototype.createSignManyStartQuery = function (text, dataObjects) {
        var _this = this;
        return function (userId, clientId) { return __awaiter(_this, void 0, void 0, function () {
            var resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.gql({
                            query: "\n        mutation StartSignMany($userId: String!, $clientId: String!, $text: String!, $dataObjects: [String!]!) { \n          signResponse: signManyStart(text: $text, dataObjects: $dataObjects, clientId: $clientId, userId: $userId) { \n            requestId, \n            collectId \n          } \n        }",
                            variables: {
                                text: text,
                                dataObjects: dataObjects,
                                userId: userId,
                                clientId: clientId
                            }
                        })];
                    case 1:
                        resp = _a.sent();
                        return [2 /*return*/, {
                                requestId: resp.data.signManyStart.requestId,
                                collectId: resp.data.signManyStart.collectId
                            }];
                }
            });
        }); };
    };
    SignManager.prototype.createSignJsonStartQuery = function (text, json) {
        var _this = this;
        return function (userId, clientId) { return __awaiter(_this, void 0, void 0, function () {
            var resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.gql({
                            query: "\n        mutation StartSign($userId: String!, $clientId: String!, $text: String!, $json: String!) { \n          signJsonStart(text: $text, json: $json, clientId: $clientId, userId: $userId) { \n            requestId, \n            collectId \n          } \n        }",
                            variables: {
                                text: text,
                                json: json,
                                userId: userId,
                                clientId: clientId
                            }
                        })];
                    case 1:
                        resp = _a.sent();
                        return [2 /*return*/, {
                                requestId: resp.data.signJsonStart.requestId,
                                collectId: resp.data.signJsonStart.collectId
                            }];
                }
            });
        }); };
    };
    SignManager.prototype.createSignManyJsonStartQuery = function (text, jsonObjects) {
        var _this = this;
        return function (userId, clientId) { return __awaiter(_this, void 0, void 0, function () {
            var resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.gql({
                            query: "\n        mutation StartSign($userId: String!, $clientId: String!, $text: String!, $jsonObjects: [String!]!) { \n          signManyJsonStart(text: $text, jsonObjects: $jsonObjects, clientId: $clientId, userId: $userId) { \n            requestId, \n            collectId \n          } \n        }",
                            variables: {
                                text: text,
                                jsonObjects: jsonObjects,
                                userId: userId,
                                clientId: clientId
                            }
                        })];
                    case 1:
                        resp = _a.sent();
                        return [2 /*return*/, {
                                requestId: resp.data.signManyJsonStart.requestId,
                                collectId: resp.data.signManyJsonStart.collectId
                            }];
                }
            });
        }); };
    };
    SignManager.prototype.signNoErrorHandling = function (signQuery, collectQuery, popup) {
        return __awaiter(this, void 0, void 0, function () {
            var serializedIdToken, idToken, userId, clientId, loa, signResp, minDelay, signature;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.signOptions.getIdToken()];
                    case 1:
                        serializedIdToken = _a.sent();
                        idToken = jwt_decode_1.default(serializedIdToken);
                        userId = idToken.sub;
                        clientId = idToken.aud;
                        loa = idToken.acr || "";
                        return [4 /*yield*/, signQuery(userId, clientId)];
                    case 2:
                        signResp = _a.sent();
                        return [4 /*yield*/, this.signInPopup(popup, signResp.requestId, loa)];
                    case 3:
                        _a.sent();
                        minDelay = new Promise(function (resolve) { return setTimeout(resolve, 500); });
                        return [4 /*yield*/, collectQuery(signResp.collectId)];
                    case 4:
                        signature = _a.sent();
                        // Make sure we get a feeling that something is signed
                        return [4 /*yield*/, minDelay];
                    case 5:
                        // Make sure we get a feeling that something is signed
                        _a.sent();
                        return [2 /*return*/, signature];
                }
            });
        });
    };
    SignManager.prototype.signInPopup = function (signPopup, requestId, loa) {
        return __awaiter(this, void 0, void 0, function () {
            var signResolve, signReject, signCompletionPromise, qs, temp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        signCompletionPromise = new Promise(function (resolve, reject) {
                            signResolve = resolve;
                            signReject = reject;
                        });
                        window.popupCallback = function () { return signResolve(); };
                        qs = query_string_1.default.stringify({
                            redirectUri: redirectUri,
                            requestId: requestId,
                            loa: loa
                        });
                        signPopup.window.location.assign(environments_1.environmentSettings[this.signOptions.environment].url + "/sign?" + qs);
                        temp = window.setInterval(function () {
                            if (signPopup.closed) {
                                signReject("Popup closed.");
                            }
                        }, 250);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 3, 4]);
                        return [4 /*yield*/, signCompletionPromise];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        window.clearInterval(temp);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    SignManager.prototype.gql = function (document) {
        return __awaiter(this, void 0, void 0, function () {
            var apiUrl, _a, _b, _c, _d, _e;
            var _this = this;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        apiUrl = environments_1.environmentSettings[this.signOptions.environment].apiUrl;
                        _a = fetch;
                        _b = [apiUrl + "/graphql"];
                        _c = {};
                        _d = {
                            "Content-Type": "application/json"
                        };
                        _e = "Bearer ";
                        return [4 /*yield*/, this.signOptions.getAccessToken()];
                    case 1: return [2 /*return*/, _a.apply(void 0, _b.concat([(_c.headers = (_d.authorization = _e + (_f.sent()),
                                _d),
                                _c.method = "POST",
                                _c.body = JSON.stringify(document),
                                _c)])).then(function (x) { return __awaiter(_this, void 0, void 0, function () {
                            var parsedResponse;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, x.json()];
                                    case 1:
                                        parsedResponse = _a.sent();
                                        if (parsedResponse.errors) {
                                            throw new SignError(parsedResponse.errors[0]);
                                        }
                                        return [2 /*return*/, parsedResponse];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    return SignManager;
}());
exports.SignManager = SignManager;
//# sourceMappingURL=SignManager.js.map